import { FC, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { Table } from '@aws-northstar/ui/components'
import { Button, Icon, Link, Popover, StatusIndicator } from '@cloudscape-design/components'

import usePlatforms from '../../hooks/query/usePlatforms'
import type { Platform } from '../../types/platforms'
import CONSTANTS from '../../constants'
import { useNewPlatformFormStore } from '../../stores/platforms/newPlatformFormStore'
import { useGenericTagsManagementFormStore } from '../../stores/tags/genericTagsManagementFormStore'
import {
	getSortedPlatformTableItems,
	type PlatformTableItem
} from '../../helper/platformList'

const PlatformOnboarding: FC = () => {
	const navigate = useNavigate()

	const clusterCreationFormStore = useNewPlatformFormStore()
	const tagCreationFormStore = useGenericTagsManagementFormStore()	
	const { data: platforms, isLoading } = usePlatforms()

	const tableItem = useMemo(
		() => getSortedPlatformTableItems(platforms || []),
		[platforms]
	)


	// if (!platforms || isLoading) return <LoadingSpinner />
	const columnDefinitions = [ 
		// {
		// 	id: 'platformID',
		// 	width: 100,
		// 	header: 'ID',
		// 	cell: (data: any) => (
		// 		<Link onFollow={() => { navigate(data.platformID) }}>
		// 			{data.platformID}
		// 		</Link>
		// 	),
		// 	sortingField: 'platformID'
		// },
		{
			id: 'platformName',
			width: 100,
			header: 'Cluster Name',
			cell: (data: Platform) => (
				<Link onFollow={() => {navigate(data.platformID)}}>
					{`atlas-${data.systemAlias}-cluster` || ''}
				</Link>
				),
			sortingField: 'platformName'
		},
			{
				id: 'environment',
				width: 100,
				header: 'Environment',
				cell: (data: PlatformTableItem) => data.environmentLabel || "",
				sortingField: 'environment'
			},
		{
			id: 'requestor',
			width: 100,
			header: 'Requested by',
			cell: (data: Platform) => data.requestorID || '',
			sortingField: 'requestorID'
		},
		{
			id: 'time',
			width: 100,
			header: 'Date Created',
			cell: (data: Platform) => {
				if (data.creationTime) {
					const date = new Date(data.creationTime);
					const localDate = date.toLocaleString("en-US", 
						{ 
						timeZone: "Asia/Singapore",
						weekday: "short",
						month: "numeric",
						day: "numeric",
						year: "numeric",
						hour: "numeric",
						minute: "numeric"
						}
					)
				
					return localDate
				}
				return ''
			},
			sortingField: 'creationTime'
		},
		{
			id: 'status',
			width: 100,
			header: 'Status',
			cell: (data: Platform) => {
				const status = data.status	// if (!applications || isLoading) return <LoadingSpinner />
				switch (status) {
					case 'PENDING_APPROVAL':
						return (
							<StatusIndicator type="in-progress" colorOverride="blue">
								Pending Approval
							</StatusIndicator>
						)
					case 'APPROVED':
						return <StatusIndicator type="success">Approved</StatusIndicator>
					case 'REJECTED':
						return <StatusIndicator type="error">Rejected</StatusIndicator>
					default:
						return null
				}
			},
			sortingField: 'status'
		}
	]

	const tableActions = (
		<div
			style={{
				display: 'flex',
				width: 220,
				marginRight: 5
			}}
		>
			<Button variant="primary" wrapText={false} onClick={() => {
				clusterCreationFormStore.actions.clearFormValues()
				clusterCreationFormStore.actions.setCurrentStep(0)
				tagCreationFormStore.actions.clearFormValues()
				navigate('/cluster/new')}}>
			New Cluster Request
		</Button>
			<div
				style={{
					marginLeft: 7,
					marginTop: 4
				}}
			>
				<Popover
					fixedWidth
					position="right"
					triggerType="custom"
					content={
						<p>
							Click the following link for a step-by-step guide on cluster
							onboarding:
							<a
								href={`${CONSTANTS.COMPASS_BASEURL}/gcp/user-guide/developer-enablement/platform-onboarding/platform_onboarding/`}
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Plus"
								style={{
									marginLeft: '5px',
									marginTop: '25px'
								}}
							>
								LINK
							</a>
						</p>
					}
				>
					<Icon name="status-info" />
				</Popover>
			</div>
		</div>
	)
	return (
		<Table
			header="Clusters"
			columnDefinitions={columnDefinitions}
			items={tableItem || []}
			actions={tableActions}
			disableRowSelect
			sortingDisabled={false}
			loading={isLoading}
		/>
	)
}

export default PlatformOnboarding
